import React, { useEffect, useState } from 'react';
import MainLogoV from "../../assets/images/main-logo-vertical.png";
import MainLogoAi from "../../assets/images/bannerLogin.svg";
import { findIsHostShipAi, validateEmail } from "../../config/utils";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import ReCaptcha from '../common/Recaptcha';
import { userRegistration } from '../../store/actions/auth';
import { passwordMinRegex } from '../../constant';
import { toast } from 'react-toastify';
import { fetchAddressByZip, getAllCountries, getStates, getSignupReasons } from '../../store/actions/shipment.action';
import { Tooltip as WmsTooltip } from "react-tooltip";
import Input from "react-phone-number-input/input";

/* istanbul ignore next */
const UserSignUp = () => {
    const [loading, setLoading] = useState(false);
    const [loadAddress, setLoadAddress] = useState(false);
    const [signUpReasonList, setSignUpReasonList] = useState([]);
    const countries = useSelector((state) => state.shipment.countries);
    const USSates = useSelector((state) => state.shipment.states);
    const [formData, setFormData] = useState({
        "firstName": "",
        "lastName": "",
        "userName": "",
        "password": "",
        "company": "",
        "companyName": "",
        "email": "",
        "addressFirst": "",
        "addressSecond": "",
        "addressThird": "",
        "city": "",
        "state": "",
        "country_Id": '218',
        "zipCode": "",
        "phoneNumber": "+1",
        "secondaryPhoneNumber": "+1",
        "signupReasonId": 1
    });
    const [captchaVal, setCaptchaVal] = useState(null);
    const [formError, setFormError] = useState({});
    const { isLoggedIn } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        getSignupReasonList();
    }, []);

    const getSignupReasonList = async () => {
        let res = await getSignupReasons();
        if (res?.data?.Status === 200) {
            let signupReasons = res?.data?.EntityList;
            if (signupReasons?.length) {
                setSignUpReasonList(signupReasons);
            }
        }
    }

    useEffect(() => {
        if (!countries.length) {
            dispatch(getAllCountries());
        }
    }, [countries]);

    useEffect(() => {
        if (!USSates?.length) {
            dispatch(getStates(218));
        }
    }, [USSates]);

    const handleFormUpdate = (e) => {
        const { name, value } = e.target;
        if (name === 'country_Id') {
            let allCountries = [...countries];
            let countryIndex = allCountries.findIndex(
                (item) => item.id === Number(value)
            );
            setFormData({
                ...formData,
                [name]: value,
                phoneNumber: `+(${countries[countryIndex].phoneCountryCode}) `,
                secondaryPhoneNumber: `+(${countries[countryIndex].phoneCountryCode}) `
            });
            setFormError({
                ...formError,
                [name]: '',
                phoneNumber: '',
                secondaryPhoneNumber: ''
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
            setFormError({
                ...formError,
                [name]: ''
            });
        }
    }
    const handleBlur = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.trim()
        });
    }

    const validateForm = () => {
        let isValid = true;
        let errors = {};

        const requiredFields = [
            "firstName",
            "lastName",
            "userName",
            "password",
            "email",
            "addressFirst",
            "city",
            "state",
            "country_Id",
            "zipCode",
            "phoneNumber",
        ];

        // Check required fields
        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field]?.trim() === "") {
                isValid = false;
                errors[field] = `${field} is required`;
            }
        });

        // Field-specific validations
        if (formData.email && !validateEmail(formData.email)) {
            isValid = false;
            errors.email = "Email is invalid";
        }

        if (formData.phoneNumber) {
            if (formData.phoneNumber.length < 10) {
                isValid = false;
                errors.phoneNumber = "Phone number is invalid";
            }
        }

        if (formData.password && !passwordMinRegex.test(formData.password)) {
            isValid = false;
            errors.password =
                "Please enter between 8 and 15 characters that contain at least one numeric, special, uppercase, and lowercase letter";
        }

        setFormError(errors);

        if (!isValid) {
            toast.error("Please fill all required fields correctly.");
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            handleUserRegistration();
        }
    };

    const handleUserRegistration = async () => {
        let formDataObject = {
            "fullName": formData.firstName + ' ' + formData.lastName,
            "userName": formData.userName,
            "password": formData.password,
            "companyName": formData.company,
            "email": formData.email,
            "signupReasonId": formData.signupReasonId,
            "address": {
                "addressFirst": formData.addressFirst,
                "addressSecond": formData.addressSecond,
                "addressThird": formData.addressThird,
                "city": formData.city,
                "state": Number(formData.country_Id) === 218 ? USSates.filter(state => state.StateCode === formData.state)[0].StateName : formData.state,
                "country_Id": formData.country_Id,
                "zipCode": formData.zipCode,
                "phoneNumber": formData.phoneNumber,
                "secondaryPhoneNumber": formData.secondaryPhoneNumber
            }
        };
        setLoading(true);
        setLoadAddress(true);
        await userRegistration(formDataObject).then((res) => {
            if (res.data.Status === 200) {
                setLoading(false);
                setLoadAddress(false);
                toast.success('User registered successfully.');
                navigate('/login');
            } else {
                toast.error(res.data?.Message?.AppStatusDescription);
                setLoading(false);
                setLoadAddress(false);
            }
        }).catch(() => {
            setLoading(false);
            setLoadAddress(false);
        });
    }

    const handleCaptchaValue = (value) => {
        setCaptchaVal(value);
    };

    if (isLoggedIn) {
        return <Navigate to="/" />;
    }

    const fetchAddress = async (event) => {
        const zipCode = event.target.value;
        if (!zipCode || zipCode.length < 5) {
            return;
        }
        setLoadAddress(true);
        let responseAddress = await Promise.resolve(fetchAddressByZip(zipCode));
        if (responseAddress?.data?.Status === 200) {
            let formErr = { ...formError };
            setLoadAddress(false);
            let address = responseAddress?.data?.Entity;
            if (address?.Country) {
                let formDataClone = { ...formData };

                let findCountry = countries.filter((country) => country.name === address?.Country)[0].id;
                formDataClone.country_Id = findCountry.toString();
                formErr.country_Id = '';

                formDataClone.state =
                    address.Country === "United States"
                        ? USSates.filter((state) => state.StateName === address?.State)[0]
                            .StateCode
                        : address?.State;
                formErr.state = '';

                formDataClone.city = address.City || formDataClone.city;
                formErr.city = '';
                setFormError(formErr);
                setFormData(formDataClone);
            }
        }
    };

    const getInputClass = (fieldName, extraClass = '') => {
        return `${extraClass} form-control ${formError[fieldName] ? 'error' : ''}`;
    };

    return (
        <div className="cus-login-pg login-form-center">
            <div>
                <div className="cus-login-pg-sec">
                    <div className="cus-login-pg-left-sec">
                        <img alt="" className="cus-main-logo-img" src={findIsHostShipAi() ? MainLogoAi : MainLogoV} />
                    </div>
                    <div className="cus-login-pg-right-sec registerBlock">
                        <div className="cus-welcome-txt">
                            Welcome to <span>{findIsHostShipAi() ? 'ShipVisionAI' : '3PLVision'}</span>
                        </div>
                        <div className="cus-login-form fontFix">
                            <div className="cus-form-sec-heading mt-2 mb-3">User Registration</div>
                            <form className="cus-form" autoComplete='off'>
                                <div className={`${loadAddress && 'loadingRegistrationForm'} registrationForm pl-1 pr-3`}>
                                    <div className='row mb-2'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                            <div>First Name</div>
                                            <input
                                                type='text'
                                                className={getInputClass('firstName', 'firstName')}
                                                value={formData.firstName}
                                                onChange={handleFormUpdate}
                                                name='firstName'
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                            <div>Last Name</div>
                                            <input
                                                type='text'
                                                className={getInputClass('lastName', 'lastName')}
                                                value={formData.lastName}
                                                onChange={handleFormUpdate}
                                                name='lastName'
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                            <div>User Name</div>
                                            <input
                                                type='text'
                                                className={getInputClass('userName', 'userName')}
                                                value={formData.userName}
                                                onChange={handleFormUpdate}
                                                name='userName'
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                            <div>Company (optional)</div>
                                            <input
                                                type='text'
                                                className='form-control'
                                                value={formData.company}
                                                onChange={handleFormUpdate}
                                                name='company'
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className='row mb-2'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                            <div>Email</div>
                                            <input
                                                type='text'
                                                className={getInputClass('email', 'email')}
                                                value={formData.email}
                                                onChange={handleFormUpdate}
                                                name='email'
                                                onBlur={handleBlur}
                                            />
                                        </div>

                                        <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                            <div>Password <i id='passwordInfo' className="fa fa-info-circle" aria-hidden="true"></i></div>
                                            <WmsTooltip
                                                anchorId={"passwordInfo"}
                                                className="tooltipTxt"
                                                place="top"
                                                content={formError.password || "Please enter between 8 and 15 characters that contain at least one numeric, special, uppercase, and lowercase letter"}
                                            />
                                            <input
                                                type='password'
                                                className={getInputClass('password', 'password')}
                                                value={formData.password}
                                                name='password'
                                                onChange={handleFormUpdate}
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                            <div>Signup Reason</div>
                                            <select
                                                className='form-control'
                                                value={formData.signupReasonId}
                                                onChange={handleFormUpdate}
                                                name='signupReasonId'
                                            >
                                                {signUpReasonList && signUpReasonList.length > 0 && signUpReasonList.map((reason) => (
                                                    <option key={reason.id} value={reason.id}>{reason.signupReason}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    <div className='addressWrapper mb-2 mt-2'>
                                        <p className='addressHead'>Address Details</p>
                                        <div className='row mb-2'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>Country</div>
                                                <select
                                                    onChange={handleFormUpdate}
                                                    value={formData.country_Id}
                                                    className={getInputClass('country_Id', 'country_Id')}
                                                    name='country_Id'
                                                >
                                                    {countries?.map((country) => (
                                                        <option
                                                            key={country.id}
                                                            value={country.id}
                                                        >
                                                            {country.name}
                                                        </option>
                                                    )
                                                    )}
                                                </select>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>Zip Code</div>
                                                <input
                                                    type='text'
                                                    className={getInputClass('zipCode', 'zipCode')}
                                                    value={formData.zipCode}
                                                    onChange={handleFormUpdate}
                                                    name='zipCode'
                                                    onBlur={fetchAddress}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mb-2'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>State</div>
                                                {parseInt(formData.country_Id) === 218 ? (
                                                    <select
                                                        onChange={handleFormUpdate}
                                                        className={getInputClass('state', 'state')}
                                                        value={formData.state}
                                                        name='state'
                                                    >
                                                        <option value="">Select</option>
                                                        {USSates &&
                                                            USSates.length > 0 &&
                                                            USSates.map((state, index) => (
                                                                <option
                                                                    value={state.StateCode || ""}
                                                                    disabled={!state.StateName}
                                                                    key={state.Id}
                                                                >
                                                                    {state.StateName}
                                                                </option>
                                                            ))}
                                                    </select>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        className={getInputClass('state', 'state')}
                                                        onChange={handleFormUpdate}
                                                        value={formData.state}
                                                        name="state"
                                                        onBlur={handleBlur}
                                                    />
                                                )}
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>City</div>
                                                <input
                                                    type='text'
                                                    className={getInputClass('city', 'city')}
                                                    value={formData.city}
                                                    onChange={handleFormUpdate}
                                                    name='city'
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mb-2'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>Phone Number</div>
                                                <Input
                                                    international
                                                    type='text'
                                                    className={getInputClass('phoneNumber', 'phoneNumber')}
                                                    value={formData.phoneNumber}
                                                    onChange={(number) => handleFormUpdate({ target: { name: 'phoneNumber', value: number } })}
                                                    name='phoneNumber'
                                                    maxLength={15}
                                                    onBlur={handleBlur}
                                                />
                                            </div>

                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>Secondary Number</div>
                                                <Input
                                                    international
                                                    type='text'
                                                    className={`form-control`}
                                                    value={formData.secondaryPhoneNumber}
                                                    onChange={(number) => handleFormUpdate({ target: { name: 'secondaryPhoneNumber', value: number } })}
                                                    name='secondaryPhoneNumber'
                                                    onBlur={handleBlur}
                                                    maxLength={15}
                                                />
                                            </div>
                                        </div>

                                        <div className='row mb-2'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>Address Line 1</div>
                                                <input
                                                    type='text'
                                                    className={getInputClass('addressFirst', 'addressFirst')}
                                                    value={formData.addressFirst}
                                                    onChange={handleFormUpdate}
                                                    name='addressFirst'
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>Address Line 2</div>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    value={formData.addressSecond}
                                                    onChange={handleFormUpdate}
                                                    name='addressSecond'
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 mobMb-10'>
                                                <div>Address Line 3</div>
                                                <input
                                                    type='text'
                                                    className='form-control'
                                                    value={formData.addressThird}
                                                    onChange={handleFormUpdate}
                                                    name='addressThird'
                                                    onBlur={handleBlur}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='pl-1 mt-1'>
                                    <ReCaptcha handleCaptchaValue={handleCaptchaValue} />
                                </div>
                            </form>

                            <div className='mt-2 palleteItemRow'>
                                <span>Already have account? <Link to={'/login'}>Login</Link></span>
                                <button
                                    className="btn cus-seconday-bg-btn loginBtn"
                                    disabled={loading || !captchaVal}
                                    onClick={handleSubmit}
                                >
                                    {loading ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : (
                                        <>Register</>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserSignUp;